// Types
import type { NotificationDashboardProps } from '@/utils/hooks/context/toast/types';

// Component
import Notification from '@/components/base/Notification';

// Route
import { DASHBOARD_VIEW } from '@/routes/privateRoutes';

const DashboardInvitationAccepted = ({ notification }: NotificationDashboardProps) => {
    return (
        <Notification
            dataNotification={notification}
            goToUrl={DASHBOARD_VIEW.replace('[id]', notification?.data?.dashboard_id.toString())}
            contentHidden={notification?.options?.hideContent ?? false}
            wide={notification?.options?.wide ?? true}>
            <Notification.Icon icon="dashboard" />
            <Notification.Content>
                <Notification.Title i18nKey="commons:notifications.dashboard_invitation_accepted.title" />
                <Notification.Description
                    i18nKey="commons:notifications.dashboard_invitation_accepted.description"
                    values={{
                        username: notification?.data?.invitation_to_user_name,
                        dashboard_title: notification?.data?.dashboard_title
                    }}
                />
            </Notification.Content>
        </Notification>
    );
};

export default DashboardInvitationAccepted;
